import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
// eslint-disable-next-line no-unused-vars
import SplashScreen from "./components/SplashScreen";
import WelcomeScreen from "./components/WelcomeScreen";
import BusinessTypeSelection from "./components/BusinessTypeSelection";
import SignupPage from "./Pages/CreateAccount/SignupPage";
import ForgotPassword from "./Pages/CreateAccount/ForgotPassword";
import VerifyOtpPage from "./Pages/CreateAccount/VerifyOtpPage";
import SuccessPage from "./Pages/CreateAccount/SuccessPage";
import ChangePassword from "./Pages/CreateAccount/ChangePassword";
import SuccessPageNew from "./Pages/CreateAccount/SuccessPageNew";
import DashboardPage from "./Pages/DashboardPage";
// ✅ new layout wrapper

import "./App.css";
import Layout from "./Pages/Layout";
import ReceiptPage from "./Pages/Receipt/Receipt";
import HomeScreen from "./Pages/Counter/Counter";
import CreateOrder from "./Pages/Counter/CreateOrder";
import TableSelectionScreen from "./Pages/Counter/TableSelectionScreen";
import OrderSummaryScreen from "./Pages/Counter/OrderSummaryScreen";
import ItemManagementScreen from "./Pages/Counter/ItemManagementScreen";
import CartScreen from "./Pages/Counter/CartScreen";
import OrderScreen from "./Pages/Order/OrderList";
import UpdateOrderEditable from "./Pages/Order/UpdateOrderEditable";
// eslint-disable-next-line no-unused-vars
import UpdateOrderViewOnly from "./Pages/Order/UpdateOrderViewOnly";
import Inventory from "./Pages/Inventory/Inventory";
import IngredientManager from "./Pages/Inventory/IngredientManager";
import ManageItems from "./Pages/Inventory/ManageItems";
import KOT from "./Pages/KOT/Kot";
import Dispatch from "./Pages/KOT/Dispatch";
import OrdersPage from "./Pages/KOT/OrdersPage";
import More from "./Pages/More/More";
import Attendance from "./Pages/More/Attendance";
import Payroll from "./Pages/More/Payroll";
import CostPrice from "./Pages/More/CostPrice";
import SellingPrice from "./Pages/More/SellingPrice";
import Profile from "./Pages/Profile/Profile";
import LanguageScreen from "./components/Languages";
import AddBusiness from "./Pages/Business/AddBusiness";
import AddBranch from "./Pages/Business/AddBranch";
import EditBusiness from "./Pages/Business/EditBusiness";
import EditBranch from "./Pages/Business/EditBranch";
import BusinessSettingsForm from "./Pages/Business/BusinessSettingsForm";
import ReceiptPrefixModal from "./Pages/Business/ReceiptPrefixModal";
// eslint-disable-next-line no-unused-vars
import AddTaxValueModal from "./Pages/Business/AddTaxValueModal";
import OwnTaxValuesList from "./Pages/Business/OwnTaxValuesList";
import OwnDiscountValuesList from "./Pages/Business/OwnDiscount";
import OwnDelivery from "./Pages/Business/OwnDeliveryFee";
import OwnPacking from "./Pages/Business/OwnPacking";
import OwnOtherFees from "./Pages/Business/OwnOtherFees";
import OwnServiceFees from "./Pages/Business/AddServiceFee";
import SubscriptionPlans from "./Pages/SubscriptionPlans";
import CustomerManagement from "./Pages/Customer/CustomerManagement";
import AddCustomer from "./Pages/Customer/AddCustomer";
import CustomerDetails from "./Pages/Customer/CustomerDetails";
import ExpenseIncome from "./Pages/ExpenseIncome/ExpenseIncome";
import ExpenseDetail from "./Pages/ExpenseIncome/ExpenseDetail";
import IncomeDetail from "./Pages/ExpenseIncome/IncomeDetail";
import VendorList from "./Pages/VendorRestaurant/vendor";
import AddVendor from "./Pages/VendorRestaurant/AddVendor";
import HelpChatList from "./Pages/Help/HelpChatList";
import ChatWindow from "./Pages/Help/ChatWindow";
import FAQList from "./Pages/Help/FAQList";
import FAQDetails from "./Pages/Help/FAQDetails";
import AttendanceList from "./Pages/Staff/AttendanceList";
import PaySlip from "./Pages/Staff/PaySlip";
import StaffManagement from "./Pages/Staff/StaffManagement";
import EditStaff from "./Pages/Staff/EditStaff";
import { PartnerPermissions } from "./Pages/Staff/PartnerPermissions";
import PayrollPreview from "./Pages/Staff/PayrollPreview";
// eslint-disable-next-line no-unused-vars
import NewStaffForm from "./Pages/Staff/NewStaffForm";
import QRCodeCard from "./Pages/Customerqr/QRCodeCard";
import ProductList from "./Pages/Customerqr/ProductList";
import ProductDetail from "./Pages/Customerqr/ProductDetail";
import CartItem from "./Pages/Customerqr/CartItem";
import { useEffect, useState } from "react";
import VendorLogin from "./Vendor/VendorLogin";
import AdminLogin from "./admin/adminLogin";
import AdminLayout from "./Pages/AdminLayout";
import ResturantUsers from "./admin/AdminResturant/Resturant";
import AddMenu from "./Pages/Menu/AddMenu";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditAllItems from "./Pages/Order/EditAllItems";
import Business from "./Pages/Business/Business";
import Branches from "./Pages/Business/Branches";
import RestaurantMenus from "./Pages/Menu/RestaurantMenus";
import EditOrder from "./Pages/Counter/EditOrder";
import EditMenu from "./Pages/Menu/EditMenu";
import SingleOrder from "./Pages/Order/SingleOrder";
// eslint-disable-next-line no-unused-vars
import EmployeeLayout from "./Pages/EmployeeLayout";
// eslint-disable-next-line no-unused-vars
import Table from "./Pages/Table/Table";
import TableScreen from "./Pages/Table/Table";
// eslint-disable-next-line no-unused-vars
import Dashboard from "./Pages/StaffLogin/StaffDashboard";
import StaffLayout from "./Pages/StaffLogin/StaffLayout";
import StaffForgotPassword from "./Pages/StaffLogin/StaffForgotPassword";
import ForgotPasswordFlow from "./Pages/Auth/ForgotPasswordFlow";
import StaffAttendance from "./Pages/StaffLogin/Attendance";
import StaffPayroll from "./Pages/StaffLogin/Payroll";
import StaffProfile from "./Pages/StaffLogin/StaffProfile";
import StaffDashboard from "./Pages/StaffLogin/StaffDashboard";
import StaffLoginScreen from "./Pages/StaffLogin/StaffLoginScreen";
import CustomerLogin from "./Pages/CustomerLogin/CustomerLogin";
import CustomerLayout from "./Pages/CustomerLogin/CustomerLayout";
import CustomerDashBoard from "./Pages/CustomerLogin/CustomerDashBoard";
import CustomerMenu from "./Pages/CustomerLogin/CustomerMenu";
import CustomerCart from "./Pages/CustomerLogin/CustomerCart";
import Payment from "./Pages/CustomerLogin/Payment";
import OrderTracking from "./Pages/CustomerLogin/OrderTracking";
import CategoryManagement from "./components/restaurant/menu/CategoryManagement";
import RolesManagement from "./Pages/Staff/RolesManagement";
import AddStaff from "./Pages/Staff/AddStaff";
// eslint-disable-next-line no-unused-vars
import StaffAddMenu from "./Pages/StaffLogin/Menu/AddMenuStaff";
import AddMenuStaff from "./Pages/StaffLogin/Menu/AddMenuStaff";
import EditMenuStaff from "./Pages/StaffLogin/Menu/EditMenuStaff";
// eslint-disable-next-line no-unused-vars
import MenuList from "./components/restaurant/menu/MenuList";
import CategoryManagementStaff from "./Pages/StaffLogin/MenuForms/CategoryManagementStaff";
import StaffRestaurantMenus from "./Pages/StaffLogin/Menu/RestaurantMenusStaff";
import StaffTableScreen from "./Pages/StaffLogin/StaffTable/StaffTable";
import RawInventoryList from "./Pages/Inventory/Inventory";
import Terms from "./Pages/Terms";
import Privacy from "./Pages/Privacy";
function App() {
  // eslint-disable-next-line no-unused-vars
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const userDatas = JSON.parse(localStorage.getItem("userData"));
    const userType = userDatas?.userType;
    setUserType(userType);

    // Show persistent logout toast
    const msgType = sessionStorage.getItem("logout_message_type");
    if (msgType) {
      sessionStorage.removeItem("logout_message_type");
      setTimeout(() => {
        if (msgType === "expired") {
          toast.error("Your session has expired. Please log in again.");
        } else if (msgType === "success") {
          toast.success("Logged out successfully.");
        }
      }, 500);
    }
  }, []);

  

  return (
    <Router>
      <Routes>
        {/* Public Pages */}
        <Route path="/" element={<WelcomeScreen />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        {/* vendor */}
        {/* {userType == "vendor" && */}(
        <>
          <Route path="/vendor/login" element={<VendorLogin />} />
        </>
        ){/* } */}



      <Route path="/restaurant-staff/employee/staffLogin" element={<StaffLoginScreen />} />
      <Route path="/staff-login" element={<StaffLoginScreen />} />
      <Route path="/reset-password" element={<ForgotPasswordFlow />} />
      <Route path="/staff-forgot-password" element={<StaffForgotPassword />} />



          <Route path="/customer" element={<CustomerLogin />} />

        <Route element={<ProtectedRoute allowedRoles={['customer']} />}>
          <Route path="/customer/" element={<CustomerLayout />}>
            <Route index element={<CustomerDashBoard />} />
            <Route path="restaurant/:id" element={<CustomerMenu />} />
            <Route path="cart" element={<CustomerCart />} />
            <Route path="payment" element={<Payment />} />
            <Route path="trackorder" element={<OrderTracking />} />
          </Route>
        </Route>


       
        {/* Keep login outside */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="restaurant">

          <Route path="businesstype" element={<BusinessTypeSelection />} />
          <Route path="signup" element={<SignupPage />} />
          <Route path="login" element={<SignupPage />} />
          <Route path="forgotpassword" element={<ForgotPassword />} />
          <Route path="otp" element={<VerifyOtpPage />} />
          <Route path="success" element={<SuccessPage />} />
          <Route path="changePassword" element={<ChangePassword />} />
          <Route path="SuccessPageNew" element={<SuccessPageNew />} />
        </Route>

        {/* ======================================= */}
        {/*       GLOBAL PROTECTED ZONE             */}     
        {/* ======================================= */}
        <Route element={<ProtectedRoute allowedRoles={['restaurant']} />}>
          <Route path="restaurant">
          {/* Dashboard & Private Pages with Sidebar */}
          <Route
            path="dashboard"
            element={
              <Layout>
                <DashboardPage />
              </Layout>
            }
          />
          <Route
            path="receipt"
            element={
              <Layout>
                <ReceiptPage />
              </Layout>
            }
          />
          <Route
            path="counter"
            element={
              <Layout>
                <HomeScreen />
              </Layout>
            }
          />
          <Route
            path="create-order"
            element={
              <Layout>
                <CreateOrder />
              </Layout>
            }
          />
          <Route
            path="table-selection"
            element={
              <Layout>
                <TableSelectionScreen />
              </Layout>
            }
          />
          <Route
            path="cart"
            element={
              <Layout>
                <CartScreen />
              </Layout>
            }
          />
          {/* orders */}
          <Route
            path="order-summary"
            element={
              <Layout>
                <OrderSummaryScreen />
              </Layout>
            }
          />
          <Route
            path="item-management"
            element={
              <Layout>
                <ItemManagementScreen />
              </Layout>
            }
          />
          <Route
            path="orders"
            element={
              <Layout>
                <OrderScreen />
              </Layout>
            }
          />
          <Route
            path="updateorder"
            element={
              <Layout>
                <UpdateOrderEditable />
              </Layout>
            }
          />
          <Route
            path="updateorder"
            element={
              <Layout>
                <UpdateOrderEditable />
              </Layout>
            }
          />
          <Route
            path="tables"
            element={
              <Layout>
                <TableScreen />
              </Layout>
            }
          />
          <Route
            path="orders/edit"
            element={
              <Layout>
                <EditAllItems />
              </Layout>
            }
          />
          <Route
            path="orders/edit/:id"
            element={
              <Layout>
                <EditOrder />
              </Layout>
            }
          />
          {/* inventory */}
          <Route
            path="inventory"
            element={
              <Layout>
                <Inventory />
              </Layout>
            }
          />
          <Route
            path="business"
            element={
              <Layout>
                <Business />
              </Layout>
            }
          />
          {/* <Route
            path="branches"
            element={
              <Layout>
                <Branches />
              </Layout>
            }
          /> */}


          <Route
            path="ingredients"
            element={
              <Layout>
                <IngredientManager />
              </Layout>
            }
          />
          <Route
            path="manageItems"
            element={
              <Layout>
                <ManageItems />
              </Layout>
            }
          />
          {/* kot */}
          <Route
            path="kot"
            element={
              <Layout>
                <KOT />
              </Layout>
            }
          />
          <Route
            path="dispatch"
            element={
              <Layout>
                <Dispatch />
              </Layout>
            }
          />
          <Route
            path="orders/:type"
            element={
              <Layout>
                <OrdersPage />
              </Layout>
            }
          />
          {/* More */}
          <Route
            path="more"
            element={
              <Layout>
                <More />
              </Layout>
            }
          />
          <Route
            path="attendance"
            element={
              <Layout>
                <Attendance />
              </Layout>
            }
          />
          <Route
            path="payroll"
            element={
              <Layout>
                <Payroll />
              </Layout>
            }
          />
          <Route
            path="cost-price"
            element={
              <Layout>
                <CostPrice />
              </Layout>
            }
          />
          <Route
            path="selling-price"
            element={
              <Layout>
                <SellingPrice />
              </Layout>
            }
          />
          {/* Customer */}
          <Route
            path="Customers"
            element={
              <Layout>
                <CustomerManagement />
              </Layout>
            }
          />
          <Route
            path="addcustomer"
            element={
              <Layout>
                <AddCustomer />
              </Layout>
            }
          />
          <Route
            path="customerDetails"
            element={
              <Layout>
                <CustomerDetails />
              </Layout>
            }
          />
          {/* Expense Income */}
          <Route
            path="expenseincome"
            element={
              <Layout>
                <ExpenseIncome />
              </Layout>
            }
          />
          <Route
            path="expensedetail"
            element={
              <Layout>
                <ExpenseDetail />
              </Layout>
            }
          />
          <Route
            path="incomedetail"
            element={
              <Layout>
                <IncomeDetail />
              </Layout>
            }
          />
          {/* Vendor Management */}
          <Route
            path="vendors"
            element={
              <Layout>
                <VendorList />
              </Layout>
            }
          />
          <Route
            path="addvendor"
            element={
              <Layout>
                <AddVendor />
              </Layout>
            }
          />
          {/* Business settings */}
          <Route
            path="addbusiness"
            element={
              <Layout>
                <AddBusiness />
              </Layout>
            }
          />
          {/* <Route
            path="addbranches"
            element={
              <Layout>
                <AddBranch />
              </Layout>
            }
          /> */}
          <Route
            path="editbusiness"
            element={
              <Layout>
                <EditBusiness />
              </Layout>
            }
          />
          {/* <Route
            path="editbranches"
            element={
              <Layout>
                <EditBranch />
              </Layout>
            }
          /> */}
          <Route
            path="business-settings"
            element={
              <Layout>
                <BusinessSettingsForm />
              </Layout>
            }
          />
          <Route
            path="reciptsPrefix"
            element={
              <Layout>
                <ReceiptPrefixModal />
              </Layout>
            }
          />
          <Route
            path="own-tax-values"
            element={
              <Layout>
                <OwnTaxValuesList />
              </Layout>
            }
          />
          <Route
            path="discount-settings"
            element={
              <Layout>
                <OwnDiscountValuesList />
              </Layout>
            }
          />
          <Route
            path="dilivery-settings"
            element={
              <Layout>
                <OwnDelivery />
              </Layout>
            }
          />
          <Route
            path="packing-fee"
            element={
              <Layout>
                <OwnPacking />
              </Layout>
            }
          />
          <Route
            path="other-fee"
            element={
              <Layout>
                <OwnOtherFees />
              </Layout>
            }
          />
          <Route
            path="service-fee"
            element={
              <Layout>
                <OwnServiceFees />
              </Layout>
            }
          />
          <Route
            path="subscriptionplans"
            element={
              <Layout>
                <SubscriptionPlans />
              </Layout>
            }
          />
          {/* Help chat */}
          <Route
            path="help"
            element={
              <Layout>
                <HelpChatList />
              </Layout>
            }
          />
          <Route
            path="chat/:id"
            element={
              <Layout>
                <ChatWindow />
              </Layout>
            }
          />
          <Route
            path="faqs"
            element={
              <Layout>
                <FAQList />
              </Layout>
            }
          />
          <Route
            path="faq/:id"
            element={
              <Layout>
                <FAQDetails />
              </Layout>
            }
          />
          {/* staff management */}
          <Route
            path="staff"
            element={
              <Layout>
                <StaffManagement />
              </Layout>
            }
          />
          <Route
            path="staff/edit/:staffId"
            element={
              <Layout>
                <EditStaff />
              </Layout>
            }
          />
          <Route
            path="roles-management"
            element={
              <Layout>
                <RolesManagement />
              </Layout>
            }
          />
          <Route
            path="permissions/:staffId"
            element={
              <Layout>
                <PartnerPermissions />
              </Layout>
            }
          />
          <Route
            path="attendance/:staffId"
            element={
              <Layout>
                <AttendanceList />
              </Layout>
            }
          />
          <Route
            path="pay-slip/:staffId"
            element={
              <Layout>
                <PaySlip />
              </Layout>
            }
          />
          <Route
            path="payroll-preview"
            element={
              <Layout>
                <PayrollPreview />
              </Layout>
            }
          />
          <Route
            path="add-staff"
            element={
              <Layout>
                <AddStaff />
              </Layout>
            }
          />
          <Route
            path="/restaurant/menus/category"
            element={
              <Layout>
                <CategoryManagement/>
              </Layout>
            }
          />
          {/* <Route path="/add-staff" element={<AddStaff />} /> */}
          <Route
            path="language"
            element={
              <Layout>
                <LanguageScreen />
              </Layout>
            }
          />
          {/* Profile */}
          <Route
            path="profile"
            element={
              <Layout>
                <Profile />
              </Layout>
            }
          />
          {/* customer QR */}
          <Route
            path="customer-qr"
            element={
              <Layout>
                <QRCodeCard />
              </Layout>
            }
          />
          <Route
            path="productlist"
            element={
              <Layout>
                <ProductList />
              </Layout>
            }
          />
          <Route
            path="productdetails"
            element={
              <Layout>
                <ProductDetail />
              </Layout>
            }
          />
          <Route path="singleorders/:id" element={<Layout>
            <SingleOrder />
          </Layout>} />

          <Route
            path="cartDetail"
            element={
              <Layout>
                <CartItem />
              </Layout>
            }
          />
          {/* {Menu} */}
          <Route
            path="menus/add"
            element={
              <Layout>
                <AddMenu />
              </Layout>
            }
          />
          <Route
            path="menus/edit"
            element={
              <Layout>
                <EditMenu />
              </Layout>
            }
          />
          <Route
            path="menus/all"
            element={
              <Layout>
                <RestaurantMenus />
              </Layout>
            }
          />
        
          </Route>
        </Route>

        {/* admin */}
        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route path="/admin" element={<AdminLayout />}>
          {/* Show dashboard when visiting /admin */}
          <Route index element={<DashboardPage />} />

          {/* Explicit dashboard path */}
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="restaurant/business" element={<ResturantUsers mode="business" />} />
          {/* <Route path="restaurant/branches" element={<ResturantUsers mode="branches" />} /> */}

          {/* Add more admin pages here */}
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['staff']} />}>
          <Route path="/restaurant-staff/employee" element={<StaffLayout />}>
            <Route index element={<StaffDashboard />} /> {/* This handles "/restaurant-staff/employee" */}
  <Route path="dashboard" element={<StaffDashboard />} />
  <Route path="profile" element={<StaffProfile />} />
  <Route path="attendance" element={<StaffAttendance />} />
  <Route path="payroll" element={<StaffPayroll />} />
  <Route path="menu" element={<AddMenuStaff />} />
  <Route path="menus/edit" element={<EditMenuStaff />} />
  <Route path="menu/categories" element={<CategoryManagementStaff />} />
  <Route path="menu/items" element={<StaffRestaurantMenus />} />
  <Route path="table" element={<StaffTableScreen/>} />
  <Route path="inventory" element={<RawInventoryList/>} />
  <Route path="kot" element={<KOT />} />
  <Route path="dispatch" element={<Dispatch />} />
  <Route path="orders" element={<OrderScreen />} />
  <Route path="orders/:type" element={<OrdersPage />} />
  <Route path="orders/edit/:id" element={<EditOrder />} />
  <Route path="roles-management" element={<RolesManagement />} />
  <Route path="more" element={<More />} />
  
  {/* POS / Counter Screens */}
  <Route path="counter" element={<HomeScreen />} />
  <Route path="create-order" element={<CreateOrder />} />
  <Route path="table-selection" element={<TableSelectionScreen />} />
  <Route path="order-summary" element={<OrderSummaryScreen />} />
  <Route path="item-management" element={<ItemManagementScreen />} />
  <Route path="cart" element={<CartScreen />} />
  
  {/* QRS / Customer QR Screens */}
  <Route path="customer-qr" element={<QRCodeCard />} />
  <Route path="productlist" element={<ProductList />} />
  <Route path="productdetails" element={<ProductDetail />} />
  <Route path="singleorders/:id" element={<SingleOrder />} />
  <Route path="cartDetail" element={<CartItem />} />
  
  {/* Additional mapped admin screens for staff */}
  <Route path="business" element={<Business />} />
  <Route path="addbusiness" element={<AddBusiness />} />
  <Route path="editbusiness" element={<EditBusiness />} />
  <Route path="customers" element={<CustomerManagement />} />
  <Route path="addcustomer" element={<AddCustomer />} />
  <Route path="customerDetails" element={<CustomerDetails />} />
  <Route path="vendors" element={<VendorList />} />
  <Route path="addvendor" element={<AddVendor />} />
  <Route path="staff" element={<StaffManagement />} />
  <Route path="staff/edit/:staffId" element={<EditStaff />} />
  <Route path="add-staff" element={<AddStaff />} />
  <Route path="expenseincome" element={<ExpenseIncome />} />
  <Route path="expensedetail" element={<ExpenseDetail />} />
  <Route path="incomedetail" element={<IncomeDetail />} />
  <Route path="help" element={<HelpChatList />} />
  <Route path="chat/:id" element={<ChatWindow />} />
  <Route path="faqs" element={<FAQList />} />
  <Route path="faq/:id" element={<FAQDetails />} />
  <Route path="receipt" element={<ReceiptPage />} />
  <Route path="language" element={<LanguageScreen />} />
</Route>
        </Route>
        {/* ======================================= */}
      </Routes>
      {/* Toast container */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Router>
  );
}

export default App;
